import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Row} from "react-bootstrap";
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { testJSON } from '../utils/jsUtils';


const CarparkSpaceAdmin_NewCarparkSpaceView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);

  // Initialize with actual JSON obj.  If not, will get error.
  const [carparkSpaceAttrs, setCarparkSpaceAttrs] = useState({
    code: '',
    description: '',
    displayCode: '',
    apiCode: '',
    type: '',
    disabledSpace: false,
    evCharger: false,
    floorId: null,
    uiPosition: '{}'
  });


  const typeList = [
    { key: "CAR",        value: "CAR" },
    { key: "MOTORCYCLE", value: "MOTORCYCLE" }
  ];

  const [floorList, setFloorList] = useState([]);

  // UI Functions

  // Initialize state
  useEffect(() => {

    fetchFloorList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchFloorList = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("locations?type=FLOOR");

        resolve(res.data);

        if (res.status === 200) {

          try {
            const res2 = await axiosAuth_PLATFORM_API.get("platform-config");

            resolve(res2.data);

            if (res2.status === 200) {

              if ((res2.data.length > 0) && res2.data[0].config && res2.data[0].config.carParkFloors) {

                let carparkFloorList = [];

                for (let i=0; i<res.data.length; i++) {
                  if (res2.data[0].config.carParkFloors.includes(res.data[i].code))
                    carparkFloorList.push(res.data[i]);
                }

                setFloorList(carparkFloorList);
              }
            }

            setErrMsg('');
          } catch (error2) {
            setErrMsg(t(translateAPIError(error2)));
          }
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  const [errMsg, setErrMsg] = useState('');

  const onAttrsInputChange = (e) => {
    setCarparkSpaceAttrs({ ...carparkSpaceAttrs, [e.target.name]: e.target.value })
  }

  const onTypeSelect = (key, event) => {
    setCarparkSpaceAttrs({ ...carparkSpaceAttrs, type: key })
  };

  const onFloorSelect = (key, event) => {
    setCarparkSpaceAttrs({ ...carparkSpaceAttrs, floorId: key })
  };

  const onCheckboxSelect = (e) => {
    setCarparkSpaceAttrs({ ...carparkSpaceAttrs, [e.target.name]: e.target.checked });
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!carparkSpaceAttrs.code || carparkSpaceAttrs.code.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_code"));
    } else if (carparkSpaceAttrs.code && carparkSpaceAttrs.code.length > 30) {
      setErrMsg(t("I18N_ERR_Max_len_code") + 30);
    } else {
      validateCode();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when code availability returns
  function validateCode() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("carpark-spaces?code=" + carparkSpaceAttrs.code);

        resolve(res.data);

        if (res.data.length > 0) {
          // CarparkSpace code is taken
          setErrMsg(t("I18N_ERR_Code_taken"));
          return;
        } else {
          validateOtherFields();
          return;
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
          validateOtherFields();
        }
        return;
      }
    });
  }

  function validateOtherFields() {
    // Validate form inputs

    if (!carparkSpaceAttrs.description || carparkSpaceAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
    } else if (carparkSpaceAttrs.description && carparkSpaceAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 200);

    } else if (!carparkSpaceAttrs.displayCode || carparkSpaceAttrs.displayCode.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_display_code"));
    } else if (carparkSpaceAttrs.displayCode && carparkSpaceAttrs.displayCode.length > 30) {
      setErrMsg(t("I18N_ERR_Max_len_display_code") + 30);

    } else if (!carparkSpaceAttrs.apiCode || carparkSpaceAttrs.apiCode.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_api_code"));
    } else if (carparkSpaceAttrs.apiCode && carparkSpaceAttrs.apiCode.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_api_code") + 50);

    } else if (!carparkSpaceAttrs.type) {
      setErrMsg(t("I18N_ERR_Need_type"));

    } else if (!carparkSpaceAttrs.floorId) {
      setErrMsg(t("I18N_ERR_Need_floor_code"));

    } else if (   (carparkSpaceAttrs.uiPosition !== '')
               && (!testJSON(carparkSpaceAttrs.uiPosition))) {
      // Validate configuration to be valid JSON
      setErrMsg(t("I18N_ERR_UI_pos_need_valid_JSON"));

    } else {
      createNewCarparkSpace();
    }
  }

  const createNewCarparkSpace = () => {

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(carparkSpaceAttrs));
    reqBody.uiPosition = JSON.parse(carparkSpaceAttrs.uiPosition);

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("carpark-spaces", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          props.onUIMode('LIST')
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    props.onUIMode('LIST')
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Carpark_Space")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_CarparkSpace_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <form>
            <Row className={classes.admin_pages__field_label}>
              <Col md={3}>{t("I18N_Code")}: *</Col>
              <Col md={3}>{t("I18N_Description")}: *</Col>
              <Col md={3}>{t("I18N_Display_code")}: *</Col>
              <Col md={3}>{t("I18N_API_code")}: *</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col md={3}>
                <input className={classes.admin_pages__field_editable} name="code" value={carparkSpaceAttrs.code}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}>
                <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={carparkSpaceAttrs.description}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}>
                <input className={classes.admin_pages__field_editable} name="displayCode" value={carparkSpaceAttrs.displayCode}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}>
                <input className={classes.admin_pages__field_editable} name="apiCode" value={carparkSpaceAttrs.apiCode}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label}>
              <Col md={3}>{t("I18N_Type")}: *</Col>
              <Col md={3}>{t("I18N_Disabled_space")}: *</Col>
              <Col md={3}>{t("I18N_EV_charger")}: *</Col>
              <Col md={3}>{t("I18N_Floor_code")}: *</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col md={3}>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={(!carparkSpaceAttrs.type || carparkSpaceAttrs.type === '') ? t("common:I18N_DROPDOWN_PROMPT") :
                          t("common:I18N_" + (typeList.find( ({ key }) => key === carparkSpaceAttrs.type )).value)}
                  onSelect={onTypeSelect}>
                  {typeList.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("common:I18N_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
              <Col><Form.Check type="switch" name={"disabledSpace"} checked={carparkSpaceAttrs.disabledSpace}
                   onChange={onCheckboxSelect} />
              </Col>
              <Col><Form.Check type="switch" name={"evCharger"} checked={carparkSpaceAttrs.evCharger}
                   onChange={onCheckboxSelect} />
              </Col>
              <Col md={3}>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={(!floorList || !carparkSpaceAttrs.floorId || carparkSpaceAttrs.floorId === '') ? t("common:I18N_DROPDOWN_PROMPT") :
                          (floorList.find( ({ id }) => id === parseInt(carparkSpaceAttrs.floorId) )).code}
                  onSelect={onFloorSelect}>
                  {floorList.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap}>
                        {item.code}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col sm={{span: 12}}>{t("I18N_UI_Position")}: *</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col sm={{span: 12}}>
                <textarea className={classes.admin_pages__field_editable} rows={10} style={{minWidth: '100%', minHeight:'50px'}} name="uiPosition"
                          value={carparkSpaceAttrs.uiPosition} onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </form>
        </Container>

      </Card>
    </>
  );
}

export default CarparkSpaceAdmin_NewCarparkSpaceView;
